import React, { useContext, Fragment } from 'react';
import Skeleton from '../../../../../../components/OtherElements/CustomSkeleton';
import BriefInfo from '../../../../../../components/User/BriefInfo';
import { store } from './Driver';

function DriverInfo() {
  const { state, refetchUserData } = useContext(store);
  const { driver } = state;

  return (
    <Fragment>
      {driver ? (
        <BriefInfo
          refetchUserData={refetchUserData}
          user={driver}
          driverId={driver.driverId}
        />
      ) : (
        <Skeleton count={3} height={38} />
      )}
    </Fragment>
  );
}

export default React.memo(DriverInfo);
